(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ketron-order-now"] && !Shopify.designMode) return;
  try {
    if (!window.__ketronOrderNow) {
    window.__ketronOrderNow = true;

    const linkForms = () => {
      document.querySelectorAll('[data-kon-form]').forEach((k) => {
        const form = document.getElementById(k.dataset.konForm);
        if (form && !form.classList.contains('kon-linked')) form.classList.add('kon-linked');
      });
    };

    document.addEventListener('click', (e) => {
      const top = e.target.closest('[data-ksb-top]');
      if (top) {
        const target = document.querySelector('.kpp, variant-picker, .kon');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      const btn = e.target.closest('.kon-btn');
      if (!btn || btn.disabled) return;
      const form = document.getElementById(btn.dataset.form);
      if (!form) return;
      btn.classList.add('is-busy');
      if (btn.dataset.action === 'order') {
        // ORDER NOW: add the selected pack, then go straight to checkout.
        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(async (res) => {
            if (!res.ok) {
              const err = await res.json().catch(() => ({}));
              throw new Error(err.description || err.message || 'Could not add this item.');
            }
            window.location.href = root + 'checkout';
          })
          .catch((err) => { alert(err.message); btn.classList.remove('is-busy'); });
        return;
      }
      // ADD TO CART: the theme's own add-to-cart (adds the pack, then opens the cart drawer).
      const real = form.querySelector('.add-to-cart-button');
      if (real) real.click();
      setTimeout(() => btn.classList.remove('is-busy'), 1200);
    });

    const syncBarText = () => {
      const chk = document.querySelector('.kpp input:checked');
      const bar = document.querySelector('[data-ksb]');
      if (!chk || !bar) return;
      const card = chk.closest('.kpp-card');
      const p = bar.querySelector('[data-ksb-price]');
      const t = bar.querySelector('[data-ksb-variant]');
      if (p && card.dataset.price && p.textContent !== card.dataset.price) p.textContent = card.dataset.price;
      if (t && card.dataset.title && t.textContent !== card.dataset.title) t.textContent = card.dataset.title;
    };
    document.addEventListener('change', (e) => { if (e.target.closest('.kpp')) syncBarText(); });

    const sync = () => {
      linkForms();
      syncBarText();
      document.querySelectorAll('.kon-btn').forEach((btn) => {
        const form = document.getElementById(btn.dataset.form);
        const add = form && form.querySelector('.add-to-cart-button');
        if (add && btn.disabled !== add.disabled) btn.disabled = add.disabled;
      });
    };

    // Keep one bottom bar, attached to the page body so it stays fixed to the screen.
    const adoptBar = () => {
      const bars = Array.from(document.querySelectorAll('[data-ksb]'));
      const fresh = bars.find((b) => b.parentElement !== document.body);
      if (!fresh) return;
      bars.forEach((b) => { if (b !== fresh) b.remove(); });
      document.body.appendChild(fresh);
    };
    // Show the bottom bar once the main buttons have scrolled out of view.
    const updateBar = () => {
      adoptBar();
      const bar = document.querySelector('[data-ksb]');
      const anchor = document.querySelector('.kon');
      if (!bar || !anchor) return;
      const r = anchor.getBoundingClientRect();
      const show = r.bottom < 0 || r.top > window.innerHeight;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    };
    new MutationObserver(() => { sync(); adoptBar(); }).observe(document.documentElement, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled'] });
    window.addEventListener('scroll', updateBar, { passive: true });
    window.addEventListener('resize', updateBar);
    document.addEventListener('DOMContentLoaded', () => { sync(); updateBar(); });
    sync();
    updateBar();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ketron-pack-picker"] && !Shopify.designMode) return;
  try {
    if (!window.__ketronPackPicker) {
    window.__ketronPackPicker = true;
    document.addEventListener('change', (e) => {
      const radio = e.target.closest('.kpp input[type="radio"]');
      if (!radio) return;
      const box = radio.closest('.kpp');
      box.querySelectorAll('.kpp-card').forEach((c) => c.classList.toggle('is-on', c.contains(radio)));
      const section = radio.closest('.shopify-section') || document;
      const inputs = section.querySelectorAll('variant-picker input[type="radio"]');
      for (const input of inputs) {
        if (input.value === radio.value) { input.click(); return; }
      }
      const sel = section.querySelector('variant-picker select');
      if (sel) { sel.value = radio.value; sel.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ketron-purchase-options"] && !Shopify.designMode) return;
  try {
    if (!window.__ketronPurchaseOptions) {
    window.__ketronPurchaseOptions = true;
    document.addEventListener('change', (e) => {
      const radio = e.target.closest('.kpo input[type="radio"]');
      if (!radio) return;
      const box = radio.closest('.kpo');
      box.querySelectorAll('.kpo-opt').forEach((o) => o.classList.toggle('is-on', o.contains(radio)));
      const hidden = box.querySelector('.kpo-input');
      if (!hidden) return;
      hidden.value = radio.value;
      hidden.disabled = radio.value === '';
    });
  }
  } catch(e) { console.error(e); }
})();

})();
